import React, { createContext, useContext, useEffect, useReducer } from 'react'
import { langTypeMap } from '../../shared/Data/langTypeMap'
import { CAT, LANG_V2, MAS, NAR, RAT, REC, REP_SEC, SUB } from '../../shared/Data/typeDirs'
import { genId } from '../../shared/utils'
import Language_v2 from '../../shared/Objects/language_v2'
import { getActionHistoryWrapWithKey } from './utils'
const actionHistoryWrap = getActionHistoryWrapWithKey('source')
export const SourceContext = createContext(null)
export const SourceReducerContext = createContext(null)
export const SourceActionHistoryContext = createContext(null)


export function SourceProvider({ children, data, onChange = () => { } }) {
  const [{ source, actionHistory }, dispatch] = useReducer(sourceReducer, { source: data, actionHistory: [] })


  useEffect(() => dispatch({ type: '_init', source: data || {} }), [data])

  useEffect(() => {
    // console.log('SourceProvider: useEffect watching source')
    onChange(source, () => source)
  }, [source, onChange])

  return (
    <SourceContext.Provider value={source}>
      <SourceActionHistoryContext.Provider value={actionHistory}>
        <SourceReducerContext.Provider value={dispatch}>
          {children}
        </SourceReducerContext.Provider>
      </SourceActionHistoryContext.Provider>
    </SourceContext.Provider>
  )
}

export function useSource() {
  return useContext(SourceContext)
}

export function useSourceActionHistory(){
  return useContext(SourceActionHistoryContext)
}


export function useSourceReducer() {
  return useContext(SourceReducerContext)
}

function sourceReducer(state, action) {
  const { source, actionHistory } = state
  switch (action.type) {

    case 'content_change':
      return actionHistoryWrap(contentChange(source, action), actionHistory, action)
    // break;
    case 'rel_change':
      return actionHistoryWrap(relChange(source, action), actionHistory, action)
    // break;
    case 'add_new_item':
      return actionHistoryWrap(addItem(source, action), actionHistory, action)
    // break;
    case 'delete_item':
      return actionHistoryWrap(deleteItem(source, action), actionHistory, action)
    // break;
    case 'add_existing_item':
      return actionHistoryWrap(addExisting(source, action), actionHistory, action)
    case 'replace_item_form_data':
      return actionHistoryWrap(replaceItemFormData(source, action), actionHistory, action)
    case 'add_multiple_language_categories':
      return actionHistoryWrap(addMultipleLanguageCategories(source, action.entries), actionHistory, action)
    case 'update_imageMap':
      return actionHistoryWrap(updateImageMap(source, action), actionHistory, action)
    case '_init':
      console.log('init source', action)
      return actionHistoryWrap(action.source, actionHistory, action)
    default:
      console.warn('default sourceReducer')
      return { source }
  }

}

function updateImageMap(source, action) {
  if (!source.imageMap) return { ...source, imageMap: action.imageData }
  return {
    ...source,
    imageMap: { ...source.imageMap, ...action.imageData }
  }
}

function addMultipleLanguageCategories(source, entries) {
  let newSource = {}
  for (let entryKey in entries) {
    newSource[entryKey] = [...source[entryKey], ...entries[entryKey].map(itm => new langTypeMap[entryKey](itm))]
    if ([NAR, REC].includes(entryKey)) {
      Language_v2.sortLangEntries({ ...source, ...newSource }, entryKey)
    } else {
      Language_v2.sortCategories({ ...source, ...newSource }, entryKey)
    }
  }
  console.log('setting this new source', newSource)
  return { ...source, ...newSource }
}

function addExisting(source, action) {

  if (!action.sourceItem) {

    let newEntry = new langTypeMap[action.typeDir]({ ...action.subItem, rel_id: genId() })
    let newCategory = [
      newEntry,
      ...source[action.typeDir]
    ].sort(sortByFullNumber)
    console.log('new catItem', action, newCategory)
    let newSource = {}

    return {
      ...source,
      ...newSource,
      [action.typeDir]: newCategory
    }
  } else {
    return source
  }

}

function deleteItem(source, action) {
  let idx = source[action.typeDir].findIndex(itm => itm._id === action.itemId)
  let newSource = {}
  for (let childType of langTypeMap[action.typeDir].getChildTypes()) {
    newSource = walkChildren(childType, source[action.typeDir][idx]._id, source)
  }
  let newCategory = [
    ...source[action.typeDir].slice(0, idx),
    ...source[action.typeDir].slice(idx + 1, source[action.typeDir].length)
  ]
  console.log('deleting item', action, idx, newSource, newCategory)
  return {
    ...source,
    ...newSource,
    [action.typeDir]: newCategory
  }
}

function walkChildren(type, _id, source, addMatchOrMiss = false) {
  let newChildren = { [type]: [] }
  let childTypes = langTypeMap[type].getChildTypes()
  for (let subItem of source[type]) {
    if (_id === subItem[langTypeMap[type].getParentAddress()]) {
      console.log('found child', type, _id, subItem[langTypeMap[type].getParentAddress()])
      for (let childType of childTypes) {
        newChildren = { ...newChildren, ...walkChildren(childType, subItem._id, { ...source, ...newChildren }), addMatchOrMiss }
      }
      if (addMatchOrMiss) newChildren[type].push(subItem)
    } else {
      if (!addMatchOrMiss) newChildren[type].push(subItem)
    }
  }
  return newChildren[type].length ? {
    // ...source,
    ...newChildren
  } : {}

}

function addItem(source, action) {
  console.log('adding item', source, action)
  if ([MAS, SUB, CAT].includes(action.itemType)) {
    return {
      ...source,
      [action.itemType]: [
        action.item,
        ...source[action.itemType]
      ].sort(sortByFullNumber)
    }
  } else if ([REC, NAR].includes(action.itemType)) {
    let newSource = {
      ...source,
      [action.itemType]: [
        action.item,
        ...source[action.itemType]
      ]
    }
    Language_v2.sortLangEntries(newSource, action.itemType)
    return newSource
  } else if ([REP_SEC, RAT].includes(action.itemType)) {
    let newSource = {
      ...source,
      [action.itemType]: [
        action.item,
        ...source[action.itemType]
      ].sort(sortByNumber)
    }
    // Language_v2.sortLangEntries(newSource, action.itemType)
    return newSource
  }
}

function relChange(source, action) {
  console.log('rel change', action, source)
  if (action.childItem) {
    let childIdx = source[action.childType].findIndex(itm => itm._id === action.childItem._id)
    let newCategory = [
      ...source[action.childType].slice(0, childIdx),
      ...source[action.childType].slice(childIdx + 1, source[action.childType].length),
    ]
    return {
      ...source,
      [action.childType]: newCategory
    }
  } else {

    let { _id, ...rest } = action.sourceItem
    // let { _id: _parentId} = action.parentItem
    let newItem = new langTypeMap[action.childType]({
      ...rest,
      [action.parentItem.getTypeAddress()]: action.parentItem[action.parentItem.getTypeAddress()],
      [`_${action.childType}`]: _id,
      [`_${LANG_V2}`]: action.parentItem[`_${LANG_V2}`]
    })
    console.log('what is this?', newItem)
    let newCategory = [newItem, ...source[action.childType]]
    return {
      ...source,
      [action.childType]: newCategory
    }
  }

}

function contentChange(source, action) {

  // console.log('source content change', source, action)
  let oldCategory = source[action.item.type]
  let oldItem = oldCategory[action.idx]
  let newItem = new langTypeMap[action.item.type]({
    ...oldItem,
    [action.address]: action.value,
    _changed: true
  })
  // console.log('log before spliced', oldCategory, newItem)
  let newCategory = [...oldCategory]
  newCategory.splice(action.idx, 1, newItem)
  // console.log('newcategory', newCategory)
  return {
    ...source,
    [action.item.type]: newCategory
  }

}

function replaceItemFormData(source, action) {
  const newItem = new langTypeMap[action.itemType]({ ...source[action.itemType][action.idx], ...action.formData, _changed: true })
  let newCategory = [
    ...source[action.itemType].slice(0, action.idx),
    newItem,
    ...source[action.itemType].slice(action.idx + 1, source[action.itemType].length)]
  return {
    ...source,
    [action.itemType]: newCategory
  }
}

function sortByFullNumber(one, two) {
  return one.fullNumber > two.fullNumber ? 1 : -1
}

function sortByNumber(one, two) {
  if ((!one.number && !two.number) || (one.number === two.number)) return one.content > two.content ? 1 : -1
  if (one.number && !two.number) return 1
  if (!one.number && two.number) return -1

  return one.number > two.number ? 1 : -1
}